import React from 'react'
import ReactDOM from 'react-dom/client'

// Google Translate'in DOM'u bozması React render'ını çökertmesin (render'dan önce kurulmalı)
import { installDomMutationGuard } from '@/lib/dom-mutation-guard'
installDomMutationGuard()

import { preloadInitialRoute } from '@/app/lazy-pages'

// Initialize Sentry before anything else
import {
  initSentry,
  SentryErrorBoundary,
  getSentryErrorHandlers,
} from '@/lib/sentry'
initSentry()

// Adres adına göre seçilen marka (kulisapp.com → Kulis) belge başlığına yansır; senseiverse.net aynen kalır.
import { applyBrandToDocument } from '@/lib/brand-document'
applyBrandToDocument()

import { App } from '@/app/App'
import { DisplayScaleProvider } from '@/app/providers/display-scale-provider'
import { DataModeProvider } from '@/app/providers/data-mode-provider'
import { RealtimeProvider } from '@/app/providers/realtime-provider'
import { QueryProvider } from '@/app/providers/query-provider'
import { UserProfileProvider } from '@/app/providers/user-profile-provider'
import { SubscriptionProvider } from '@/app/providers/subscription-provider'
import { ThemeProvider } from '@/app/providers/theme-provider'
import { SupportModalProvider } from '@/app/providers/support-modal-provider'
import { ErrorFallback } from '@/components/error-fallback'

import '@fontsource/geist-sans/index.css'
import 'flag-icons/css/flag-icons.min.css'
import '@/styles/global.css'
import { Toaster } from '@/components/ui/sonner'

// React 19+ error handlers for catching errors outside ErrorBoundary
const errorHandlers = getSentryErrorHandlers()

// Açılış sayfasının kodu inmeden çizime başlanmaz (hazır HTML'li herkese açık sayfalarda boş an olmasın, #1090)
function mount() {
  ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
    errorHandlers,
  ).render(
    <React.StrictMode>
      <ThemeProvider>
        <QueryProvider>
          <SubscriptionProvider>
            <SupportModalProvider>
              <SentryErrorBoundary fallback={ErrorFallback} showDialog>
                <DisplayScaleProvider>
                  <DataModeProvider>
                    <RealtimeProvider>
                      <UserProfileProvider>
                        <App />
                        <Toaster />
                      </UserProfileProvider>
                    </RealtimeProvider>
                  </DataModeProvider>
                </DisplayScaleProvider>
              </SentryErrorBoundary>
            </SupportModalProvider>
          </SubscriptionProvider>
        </QueryProvider>
      </ThemeProvider>
    </React.StrictMode>,
  )
}

void preloadInitialRoute(window.location.pathname).then(mount, mount)
